import { Icon, IconProps } from "../";

export const SendIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M3.07422 2.32421C2.84185 2.21272 2.56873 2.22796 2.35059 2.36522C2.1324 2.50251 2 2.74221 2 2.99999V9.99999C2 10.3521 2.24498 10.6568 2.58887 10.7324L11.5622 11.7507C11.8579 11.7843 11.858 12.2139 11.5622 12.2475L2.5918 13.2666C2.24664 13.3412 2 13.6469 2 14V21C2 21.2578 2.1324 21.4975 2.35059 21.6348C2.56873 21.772 2.84185 21.7873 3.07422 21.6758L21.3555 12.9014C22.1112 12.5382 22.1112 11.4618 21.3555 11.0986L3.07422 2.32421Z" />
    </Icon>
  );
};
